import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { PROGRAMS } from "../data";

const spans = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7", "lg:col-span-6", "lg:col-span-6", "lg:col-span-4", "lg:col-span-8", "lg:col-span-12"];

export const Programs = ({ onCardClick, items = PROGRAMS, showHeader = true, cta = "Learn More" }) => (
  <section id="training" className="py-24 lg:py-32 bg-[var(--paper)]" data-testid="programs">
    <div className="max-w-7xl mx-auto px-6">
      {showHeader && (
        <div className="max-w-2xl mb-16">
          <Reveal><Overline>Pilot Training Programs</Overline></Reveal>
          <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-[var(--primary)]">Your pathway to the flight deck.</h2></Reveal>
          <Reveal delay={0.15}><p className="mt-5 text-[var(--muted)] text-base md:text-lg">From your very first discovery flight to a commercial licence and beyond — tailor-made programmes for every stage.</p></Reveal>
        </div>
      )}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 auto-rows-fr">
        {items.map((p, i) => (
          <Reveal key={p.key} delay={(i % 2) * 0.08} className={spans[i % spans.length]}>
            <button onClick={() => onCardClick?.(p)} data-testid={`program-card-${p.key}`}
              className="group relative w-full h-full min-h-[300px] rounded-2xl overflow-hidden text-left card-shadow">
              {p.type === "video" ? (
                <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"><source src={p.img} type="video/mp4" /></video>
              ) : (
                <img src={p.img} alt={p.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f3159]/95 via-[#164275]/35 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-7">
                <div className="flex items-center gap-3 mb-3">
                  <span className="glass px-3 py-1 rounded-full text-[11px] text-white/90">{p.level}</span>
                  <span className="glass px-3 py-1 rounded-full text-[11px] text-white/90">{p.duration}</span>
                </div>
                <h3 className="font-display text-2xl font-semibold text-white">{p.title}</h3>
                <p className="mt-2 text-sm text-white/70 max-w-md">{p.desc}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-accent-2 text-sm font-medium">{cta} <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" /></span>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
